'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { Alert, Button, TextField, Typography } from '@mui/material';

import { StyledLoginForm } from '../../Login/components/elements';
import { recoveryPassword } from '../hooks/useRecoveryPassword';

export function RecoveryPasswordForm() {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [apiError, setApiError] = useState('');

  function validate() {
    if (!email) {
      setEmailError('Digite um e-mail');
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError('Digite um e-mail válido');
      return false;
    }
    setEmailError('');
    return true;
  }

  async function handleSubmit() {
    if (!validate()) return;
    setIsSubmitting(true);
    setApiError('');
    try {
      await recoveryPassword(email);
      setSuccess(true);
    } catch {
      setApiError(
        'Não foi possível resetar a senha. Confira o e-mail e tente novamente.'
      );
    } finally {
      setIsSubmitting(false);
    }
  }

  if (success) {
    return (
      <StyledLoginForm>
        <Alert severity="success">Senha resetada.</Alert>
        <Button
          variant="outlined"
          sx={{ textTransform: 'none' }}
          onClick={() => router.push('/login')}
          size="large"
        >
          Voltar ao login
        </Button>
      </StyledLoginForm>
    );
  }

  return (
    <StyledLoginForm>
      {apiError && (
        <Typography sx={{ color: theme => theme.palette.error.light }}>
          {apiError}
        </Typography>
      )}

      <TextField
        disabled={isSubmitting}
        value={email}
        onChange={e => {
          setEmail(e.target.value.trim());
          setEmailError('');
        }}
        error={emailError !== ''}
        helperText={emailError}
        id="email"
        type="email"
        label="E-mail"
        variant="filled"
        sx={{ marginBottom: theme => theme.spacing(4) }}
      />

      <Button
        disabled={isSubmitting || email === ''}
        type="submit"
        color="primary"
        variant="contained"
        sx={{ textTransform: 'none' }}
        onClick={e => {
          e.preventDefault();
          handleSubmit();
        }}
        size="large"
      >
        Enviar
      </Button>

      <Button
        disabled={isSubmitting}
        type="button"
        variant="text"
        sx={{ textTransform: 'none' }}
        onClick={() => router.push('/login')}
        size="large"
      >
        Voltar ao login
      </Button>
    </StyledLoginForm>
  );
}
